export default [
  {
    path: '/download',
    name: 'Download',
    component: () => import('./index.vue'),
    meta: {
      title: '速达觅客'
    }
  }
];
